import store from '../..';

export function callString() {
  return store.getters['account/getCurrentClient'].client_name === 'shark'
    ? // Shark
    `{
    uuid
    ad_schedule
    beep
    charged_off
    area_id
    group_id
    group_name
    store_id
    debug
    device_id
    notify_users
    phone_number
    launch_mode
    gpsi_car_number
    gpsi_car_id
    imei
    mdn
    screen_uptime
    car_number
    session_status
    launch_mode
    status
    version
    trip_type
    session_type
    checked
    pushy_token
    twilio
    last_activity
    total
    network_status
    active_in_round
    error
    success
  }`
    : // Avis Bazzbi
    `{
    uuid,
    ad_schedule,
    beep,
    charged_off,
    area_id,
    group_id,
    store_id,
    debug,
    device_id,
    notify_users,
    phone_number,
    screen_uptime,
    session_status,
    status,
    version,
    trip_type,
    session_type,
    checked,
    pushy_token,
    twilio,
    last_activity,
    error, 
    success
  }`;
}

export const roundCallString = `{
  uuid,
  end_time,
  start_time,
  gpsi_car_number,
  gpsi_car_id,
  mdn,
}`;
// guid,
// screen_id,
// group_id,
// imei,
// elapsed_time,
// holes_completed,
// nine_hole_factor,
// course_launch_intent_mode,
// gpsi_server,
// gpsi_course_site_id,
// consumer_purchases,
// billable,
// error,
// success

const filterParams = [
  'group_id',
  'ad_schedule',
  'area_id',
  'version',
  'session_status',
  'launch_mode',
  'trip_type',
];

const _filterParams = filterParams;
export { _filterParams as filterParams };
